// extracted by mini-css-extract-plugin
module.exports = {"PageEmailLanding":"PageEmailLanding___2csJU","customerVoiceList":"customerVoiceList___1OT4b","emphasis":"emphasis___1A3XG"};